import React from "react";
import TeamManagement from "../views/clientView/team/TeamManagement";

export default function Team() {
  return <TeamManagement />;
}
